import { defineMessages } from 'react-intl';

export const chatDockMessages = defineMessages({
  open: {
    id: 'chatDock.open',
    defaultMessage: 'Open Zori',
  },
  close: {
    id: 'chatDock.close',
    defaultMessage: 'Close Zori',
  },
  title: {
    id: 'chatDock.title',
    defaultMessage: 'Zori',
  },
  headerTitle: {
    id: 'chatDock.headerTitle',
    defaultMessage: 'Zori AI',
  },
  recentConversations: {
    id: 'chatDock.recentConversations',
    defaultMessage: 'Recent conversations',
  },
  newChat: {
    id: 'chatDock.newChat',
    defaultMessage: 'New chat',
  },
  patientContext: {
    id: 'chatDock.patientContext',
    defaultMessage: 'Patient Context:',
  },
  patientContextOptional: {
    id: 'chatDock.patientContextOptional',
    defaultMessage: 'Optional',
  },
  patientSearchPlaceholder: {
    id: 'chatDock.patientSearchPlaceholder',
    defaultMessage: 'Search patients',
  },
  startWithoutPatient: {
    id: 'chatDock.startWithoutPatient',
    defaultMessage: 'Start without patient',
  },
  populationChatTitle: {
    id: 'chatDock.populationChatTitle',
    defaultMessage: 'Zori AI',
  },
  noConversations: {
    id: 'chatDock.noConversations',
    defaultMessage: 'No recent conversations yet.',
  },
  loading: {
    id: 'chatDock.loading',
    defaultMessage: 'Loading conversations...',
  },
  noMessages: {
    id: 'chatDock.noMessages',
    defaultMessage: 'No messages yet.',
  },
  back: {
    id: 'chatDock.back',
    defaultMessage: 'Back to conversations',
  },
  removeConversation: {
    id: 'chatDock.removeConversation',
    defaultMessage: 'Remove conversation',
  },
  missingPatient: {
    id: 'chatDock.missingPatient',
    defaultMessage: 'Missing subject details.',
  },
  untitled: {
    id: 'chatDock.untitled',
    defaultMessage: 'Conversation',
  },
  maskedModeDisabled: {
    id: 'chatDock.maskedModeDisabled',
    defaultMessage: 'Patient search is unavailable in masked mode.',
  },
});
